export default function parseQuery(fullUrl: any){
    const url = new URL(fullUrl);
    const query: any = {};
    url.searchParams.forEach((v, k) => (query[k] = v));
    return query;
}